var Handlebars = require("../../estrella.thomasjacob.de/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p class=\"vertical-middle\">\n	<i class=\"fa fa-cog fa-spin fa-2x\"></i>&ensp;Bitte warten...\n</p>\n";
},"useData":true});